export function getUserName(client?: {firstName?: string | null, lastName?: string | null}): string {
  const firstName = client?.firstName;
  const lastName = client?.lastName;
  let name = '';
  if (!firstName && !lastName) {
    name = 'Unknown user';
  } else {
    name = [firstName, lastName].join(' ');
  }
  return name
}
